/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionStatusEnum } from './SubscriptionStatusEnum';
import {
    SubscriptionStatusEnumFromJSON,
    SubscriptionStatusEnumFromJSONTyped,
    SubscriptionStatusEnumToJSON,
} from './SubscriptionStatusEnum';

/**
 * 
 * @export
 * @interface SubscriptionInfoOut
 */
export interface SubscriptionInfoOut {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionInfoOut
     */
    id?: number;
    /**
     * 
     * @type {SubscriptionStatusEnum}
     * @memberof SubscriptionInfoOut
     */
    status?: SubscriptionStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionInfoOut
     */
    basePrice?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionInfoOut
     */
    discountValue?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionInfoOut
     */
    finalPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionInfoOut
     */
    rxCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionInfoOut
     */
    rxConsumed?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionInfoOut
     */
    rxRemaining?: number;
    /**
     * 
     * @type {Date}
     * @memberof SubscriptionInfoOut
     */
    subscribedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SubscriptionInfoOut
     */
    expiredAt?: Date;
}

/**
 * Check if a given object implements the SubscriptionInfoOut interface.
 */
export function instanceOfSubscriptionInfoOut(value: object): boolean {
    return true;
}

export function SubscriptionInfoOutFromJSON(json: any): SubscriptionInfoOut {
    return SubscriptionInfoOutFromJSONTyped(json, false);
}

export function SubscriptionInfoOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionInfoOut {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'status': json['status'] == null ? undefined : SubscriptionStatusEnumFromJSON(json['status']),
        'basePrice': json['base_price'] == null ? undefined : json['base_price'],
        'discountValue': json['discount_value'] == null ? undefined : json['discount_value'],
        'finalPrice': json['final_price'] == null ? undefined : json['final_price'],
        'rxCount': json['rx_count'] == null ? undefined : json['rx_count'],
        'rxConsumed': json['rx_consumed'] == null ? undefined : json['rx_consumed'],
        'rxRemaining': json['rx_remaining'] == null ? undefined : json['rx_remaining'],
        'subscribedAt': json['subscribed_at'] == null ? undefined : (new Date(json['subscribed_at'])),
        'expiredAt': json['expired_at'] == null ? undefined : (new Date(json['expired_at'])),
    };
}

export function SubscriptionInfoOutToJSON(value?: SubscriptionInfoOut | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'status': SubscriptionStatusEnumToJSON(value['status']),
        'base_price': value['basePrice'],
        'discount_value': value['discountValue'],
        'final_price': value['finalPrice'],
        'rx_count': value['rxCount'],
        'rx_consumed': value['rxConsumed'],
        'rx_remaining': value['rxRemaining'],
        'subscribed_at': value['subscribedAt'] == null ? undefined : ((value['subscribedAt'] as any).toISOString()),
        'expired_at': value['expiredAt'] == null ? undefined : ((value['expiredAt'] as any).toISOString()),
    };
}

